uniform sampler2D uPositions;
uniform float uSize;
uniform float uPixelRatio;
uniform vec2 uResolution;
uniform float uScroll;
uniform float uEntrance;
uniform float uTime;
uniform float uIdle;
varying vec3 vPos;
varying vec2 vUv;
void main() {

  vec3 pos = texture2D( uPositions, position.xy ).xyz;

  float drift = uIdle * 0.06;
  pos.x += sin(uTime * 1.3 + position.x * 47.0 + position.y * 31.0) * cos(uTime * 0.9 + position.y * 53.0) * drift;
  pos.y += cos(uTime * 1.1 + position.y * 41.0 + position.x * 37.0) * sin(uTime * 0.7 + position.x * 59.0) * drift;
  pos.z += sin(uTime * 0.8 + position.x * 43.0 + position.y * 29.0) * cos(uTime * 1.0 + position.y * 51.0) * drift;

  float customSize = uSize;

  vec4 modelPosition = modelMatrix * vec4(pos, 1.0);
  vec4 viewPosition = viewMatrix * modelPosition;
  vec4 projectionPosition = projectionMatrix * viewPosition;

  gl_Position = projectionPosition;
  gl_PointSize = customSize * uResolution.y * 0.0013;
  gl_PointSize *= (1.0 / - viewPosition.z);
  gl_PointSize *= uEntrance;

  vPos = pos;
}
